import { render, staticRenderFns } from "./AlertContainer.vue?vue&type=template&id=55cf886e&scoped=true"
import script from "./AlertContainer.vue?vue&type=script&lang=js"
export * from "./AlertContainer.vue?vue&type=script&lang=js"
import style0 from "./AlertContainer.vue?vue&type=style&index=0&id=55cf886e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cf886e",
  null
  
)

export default component.exports